import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ShippingAccounting } from '../../../domain/entities/shipping-accounting.entity';

@Component({
  selector: 'app-shipping-accounting-list',
  templateUrl: './shipping-accounting-list.component.html',
  styleUrls: ['./shipping-accounting-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShippingAccountingListComponent {
  @Input() items: readonly ShippingAccounting[] = [];
  @Input() downloadingCsvFor: string | null = null;

  @Output() readonly downloadCsvClick = new EventEmitter<ShippingAccounting>();
  @Output() readonly sendEmailClick = new EventEmitter<ShippingAccounting>();
}
